/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Carousel_NextInputs */

const da_forside_carousel_next = /** @type {(inputs: Forside_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Næste citat`)
};

/** @type {(inputs: Forside_Carousel_NextInputs) => LocalizedString} */
const en_forside_carousel_next = da_forside_carousel_next;

/**

* @param {Forside_Carousel_NextInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_carousel_next = /** @type {((inputs?: Forside_Carousel_NextInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Carousel_NextInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_carousel_next(inputs)
	return /** @type {LocalizedString} */ ("Næste citat")
});